import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Facebook, Instagram } from "lucide-react";

const FAQS = [
  { q: "Comment fonctionne Go Helper ?", a: "Tu publies une tâche avec un prix, un helper local accepte, tu paies via Go Helper qui garde le montant en fiducie, et le paiement est libéré une fois la tâche confirmée." },
  { q: "Est-ce sécuritaire ?", a: "Oui. Toutes les transactions passent par Go Helper. La messagerie interne et l'historique protègent les deux parties." },
  { q: "Quelle est la commission ?", a: "Frais fixe de 3 $ + 15 % de commission sur le sous-total helper. L'option urgence ajoute 30 % au prix de base, versés au helper." },
  { q: "Quand le helper est-il payé ?", a: "Une fois que tu confirmes que la tâche est terminée. Le montant est automatiquement libéré." },
  { q: "Puis-je annuler ?", a: "Oui, avant le paiement ou avant l'arrivée du helper. Un litige peut être ouvert en cas de problème." },
  { q: "Comment devient-on Helper Pro ?", a: "Après 50 tâches complétées avec de bonnes évaluations. Les autres paliers : Helper actif (10), Helper fiable (25)." },
];

export default function Help() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="text-3xl md:text-4xl font-heading font-black text-navy">Centre d'aide</h1>
        <p className="text-[#475569] mt-1">Les réponses aux questions les plus fréquentes.</p>
      </div>

      <div className="card-surface p-6">
        <Accordion type="single" collapsible>
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`q${i}`} data-testid={`faq-${i}`}>
              <AccordionTrigger className="font-heading font-bold text-navy text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[#475569]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <div className="bg-navy text-white rounded-2xl p-6 relative overflow-hidden noise">
        <h2 className="font-heading font-black text-xl text-white">Besoin de plus d'aide ?</h2>
        <p className="text-white/80 mt-1">
          Écris-nous à <a href="mailto:gohelperservice@outlook.com" className="text-lime font-bold hover:underline" data-testid="help-email">gohelperservice@outlook.com</a>
        </p>
        <div className="flex items-center gap-3 mt-4">
          <a
            href="https://www.facebook.com/share/18mKMi1XR1/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook Go Helper"
            className="h-11 w-11 rounded-full bg-lime text-navy flex items-center justify-center hover:bg-limeHover transition-colors"
            data-testid="help-fb-link"
          >
            <Facebook size={20} fill="currentColor" strokeWidth={0} />
          </a>
          <a
            href="https://www.instagram.com/gohelperservice?igsh=ZWZuYXRxcnprd3V2"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram Go Helper"
            className="h-11 w-11 rounded-full text-white flex items-center justify-center"
            style={{ background: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)" }}
            data-testid="help-ig-link"
          >
            <Instagram size={20} />
          </a>
          <span className="text-white/70 text-sm">Retrouve-nous sur les réseaux</span>
        </div>
      </div>
    </div>
  );
}
